<template>
	<div class="layout-topbar clearfix">

		<button class="layout-topbar-logo p-link">
			<button class="p-link nome-sistema">
				<img id="layout-menu-logo" src="assets/layout/images/logo_tribunal.png" alt="Tribunal de Contas do Estado do Amazonas"/>
				<p>Sistema de Processos Seletivos</p>
			</button>
		</button>

		<button class="layout-menu-button p-link" @click="onMenuButtonClick">
			<i class="pi pi-bars"></i>
		</button>

		<button id="topbar-menu-button" class="p-link" @click="onTopbarMenuButtonClick">
			<i class="pi pi-ellipsis-v"></i>
		</button>

		<div class="grid p-fluid">

			<div class="col-12 md:col-6">
				<Dropdown class="mr-2" :options="listaProcessos" dataKey="id" v-model="processoSelecionado" optionLabel="nomeCompleto" optionDisabled="grupo" v-if="isAcessoAdmin">
					<template #option="slotProps">
						<div class="flex align-items-center country-item" v-if="slotProps.option.grupo">
							<i class="pi pi-align-justify"/>
							<label>{{slotProps.option.nomeCompleto}}</label>
						</div>
						<div class="flex align-items-center country-item" v-else>
							<div>{{slotProps.option.nomeCompleto}}</div>
						</div>
					</template>
				</Dropdown>
			</div>

			<div class="col-12 md:col-6">
				<ul :class="topbarItemsClass">

					<li :class="[{'active-topmenuitem': activeTopbarItem === 'settings'}]"
						@click="$emit('topbar-item-click',{originalEvent:$event,item:'settings'})">
						<button class="p-link" @click="efetuarLogout">
							<i class="topbar-icon pi pi-sign-out"></i>
							<span class="topbar-item-name">Sair</span>
						</button>
					</li>

					<li :class="[{'active-topmenuitem': activeTopbarItem === 'settings'}]"
						@click="$emit('topbar-item-click',{originalEvent:$event,item:'settings'})">
						<div class="align-content-center text-base nome-usuario mt-2 justify-content-center">
							<span>{{nome}}</span>
						</div>
					</li>

					<li :class="[{'active-topmenuitem': activeTopbarItem === 'notifications'}]"
						@click="$emit('topbar-item-click',{originalEvent:$event,item:'notifications'})">

						<transition name="layout-submenu-container">
							<ul class="fadeInDown" v-show="activeTopbarItem === 'notifications'">
								<li role="menuitem">
									<router-link :to="{ name: 'meu.cadastro'}">
										<button class="p-link">
											<i class="pi pi-user-edit"></i>
											<span>Meu cadastro</span>
										</button>
									</router-link>
								</li>
							</ul>
						</transition>
					</li>
				</ul>
			</div>

		</div>
	</div>
</template>

<script>
	import { logoutMixin } from '@/mixins'
	import ProcessoService from './service/ProcessoService';

	export default {
    data: function () {
        return {
            mensagemErro: "",
            usuario: this.$store.state.usuario,
            nome: this.$store.state.nome,
            listaSelecao: [],
			processoSelecionadoTopBar: null,
			processoService: null,
			grupoProcessoSelecao: [],
			isAcessoAdmin: false,
        };
    },
    mixins: [logoutMixin],
    props: {
        topbarMenuActive: Boolean,
        activeTopbarItem: String,
        profileMode: String,
        horizontal: Boolean
    },
    created() {
		this.processoService = new ProcessoService();
        this.getListaSelecao();
    },
    methods: {
        onMenuButtonClick(event) {
            this.$emit("menubutton-click", event);
        },
        onTopbarMenuButtonClick(event) {
            this.$emit("topbar-menubutton-click", event);
        },
        getListaSelecao() {
			this.isAcessoAdmin = this.$store.state.perfil == 'CANDIDATO' ? false : true;
			if (this.$store.state.username) {
				this.processoService.atualizarListaProcessos();
			}
        }
    },
    computed: {
        topbarItemsClass() {
            return ["topbar-menu fadeInDown", {
                    "topbar-menu-visible": this.topbarMenuActive
                }];
        },
		listaProcessos: {
			get() {
				return this.$store.state.listaProcessos;
			},
		},
		processoSelecionado: {
			get() {
				return this.$store.state.processoSelecionado;
			},
			set(value) {
				if (value) {
					this.$store.commit('setProcessoSelecionado', value);
				}
			}
		}

    },
}
</script>

<style scoped>

.nome-usuario {
		color: #ffffff;
		font-size: 1.5rem;
	}

@media screen and (max-width: 880px)
{
	.nome-usuario {
		color: black;
		font-size: 1.5rem;
	}
}


</style>